import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BackgroundCheckService {
  public getStatus(): Observable<any> {
    return of(null);
  }
}
